import { EnemyActor } from "../../enemy-actors/EnemyActor";
import { GameVars } from "../../../../GameVars";
import { FireTurretActor } from "../FireTurretActor";
import { GameConstants } from "../../../../../engine/src";
import { AudioManager } from "../../../../AudioManager";

export class FireBeam extends Phaser.GameObjects.Container {

    private fireTurretActor: FireTurretActor;
    private enemyActors: EnemyActor[];
    private f: number;
    private framesDuration: number;
    private impact_x: number[];
    private impact_y: number[];
    private audioLoopStopped: boolean;

    constructor(scene: Phaser.Scene, fireTurretActor: FireTurretActor, enemyActors: EnemyActor[]) {

        super(scene);

        this.fireTurretActor = fireTurretActor;
        this.enemyActors = enemyActors;
        this.f = 0;
        this.framesDuration = GameVars.timeStepFactor === 1 ? 16 : 4;
        this.audioLoopStopped = false;

        this.impact_x = [];
        this.impact_y = [];

        for (let i = 0; i < this.enemyActors.length; i++) {
            this.impact_x.push(this.enemyActors[i].x);
            this.impact_y.push(this.enemyActors[i].y - 20);
        }

        let emmission_x = this.fireTurretActor.x + this.fireTurretActor.canonLength * Math.cos(this.fireTurretActor.canonRotation - Math.PI / 2);
        let emmission_y = this.fireTurretActor.y + (this.fireTurretActor.canonLength * Math.sin(this.fireTurretActor.canonRotation - Math.PI / 2)) * .7 - 55;

        let flame = this.scene.add.sprite(emmission_x, emmission_y, "texture_atlas_3", "flame_00");
        flame.setOrigin(.5, 1);
        flame.scaleY = Math.hypot(this.impact_y[0] - emmission_y, this.impact_x[0] - emmission_x) / flame.height + .1;
        flame.setAngle(Math.atan2(this.impact_y[0] - emmission_y, this.impact_x[0] - emmission_x) * 180 / Math.PI + 90);
        this.add(flame);

        if (flame.scaleY < .2) {
            flame.scaleY = .2;
        } else if (flame.scaleY > 1.2) {
            flame.scaleY = 0;
        }

        flame.anims.play("flame");

        const flare = new Phaser.GameObjects.Image(this.scene, emmission_x, emmission_y, "texture_atlas_1", "flare_orange");
        flare.alpha = 0;
        flare.setScale(0);
        this.add(flare);

        this.scene.tweens.add({
            targets: flare,
            alpha: .8,
            scaleX: .75,
            scaleY: .75,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 300 : 100,
            onComplete: () => {
                AudioManager.stopSound("flamer", true);
                flare.destroy();
            },
            onCompleteScope: this
        });

        this.scene.sys.updateList.add(this);

        if(!GameVars.battleOver) {
            AudioManager.playSound("flamer", true, .55 + .15 * fireTurretActor.anutoTurret.level, 1 - .1 * fireTurretActor.anutoTurret.level);
        }
    }

    public preUpdate(time: number, delta: number): void {

        this.enemyActors.forEach(function (enemyActor) {
            if (enemyActor.type !== GameConstants.ENEMY_FIRE) {
                enemyActor.burn();
            }
        }); 

        if(GameVars.battleOver && !this.audioLoopStopped) {
            this.audioLoopStopped = true;
            AudioManager.stopSound("flamer", true);
        }

        if (this.f ++ === this.framesDuration) {

            this.enemyActors.forEach(function (enemyActor) {
                enemyActor.onFireAttackEnded();
            }); 

            this.destroy();
        } 
    }
}
